<template>
  <main class="product-categories catalog-page">
    <div v-if="categories && categories.length" class="catalog-page__category category">
      <filter-wrapper
        class="category__filter"
        :itemsQty="categories.length"
        :isGrid="isGrid"
        :isList="isList"
        :optionsList="sorting"
        @gridClicked="toggleGrid"
        @listClicked="toggleList"
      />
      <div class="category__items-wrapper" :class="{ 'category__items-wrapper--list': isList }">
        <router-link
          v-for="(item, n) in categories"
          :key="`${item.slug}-${n}`"
          class="category__item"
          :to="item.link"
        >
          <div class="category__img-wrapper">
            <img
              :src="getImageUrl(item.icon)"
              :alt="getImageAlt(item.icon, item.title)"
              class="category__img"
            />
          </div>
          <div class="category__copy-wrapper">
            <h3 class="text-color-navy category__item-title text-h3" v-html="item.title" />
            <p
              v-if="item.tileDescription"
              class="category__item-description text-description"
              v-html="item.tileDescription"
            />
          </div>
        </router-link>
      </div>
    </div>
  </main>
</template>
<script>
import { ref } from 'vue'

import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'
import FilterWrapper from '@/components/common/FilterWrapper.vue'

import { usePageMeta } from '@/composables/usePageMeta'
import { useSorting } from '@/composables/useSorting'
import { useSortingMethods } from '@/composables/useSortingMethods'

export default {
  name: 'ProductCategories',
  components: {
    FilterWrapper,
  },
  props: {
    cPage: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { setPageMeta } = usePageMeta()
    const { sortByAlphaAsc, sortByAlphaDesc } = useSortingMethods()
    const { getImageUrl, getImageAlt } = useContentfulComponent()

    const categories = ref([])

    const doAlphaAscSort = () => {
      categories.value = sortByAlphaAsc(categories.value, 'title')
    }
    const doAlphaDescSort = () => {
      categories.value = sortByAlphaDesc(categories.value, 'title')
    }
    const { sorting } = useSorting({
      initialSorting: {
        selected: 'A - Z',
        options: ['A - Z', 'Z - A'],
      },
      customSortFunctions: { doAlphaAscSort, doAlphaDescSort },
    })

    setPageMeta(props.cPage?.fields?.pageMeta)

    return {
      categories,
      sorting,
      getImageUrl,
      getImageAlt,
    }
  },
  data() {
    return {
      isGrid: true,
      isList: false,
    }
  },
  mounted() {
    const subpages = this.cPage?.fields?.subpages?.length
      ? this.cPage.fields.subpages.map((el) => ({
          ...el.fields,
          slug: el.fields.slug,
          link: this.$contentful.service.getPageBySlug(el.fields.slug)?.link,
        }))
      : null
    this.categories = subpages
  },
  methods: {
    toggleList() {
      this.isList = true
      this.isGrid = false
    },
    toggleGrid() {
      this.isGrid = true
      this.isList = false
    },
  },
}
</script>
